import { sanitizeListColumns } from '../../util/sanitizeListColumns'
import ChartOfAccountsListColumnModel from '../../../modules/settings/components/tax-settings/chart-of-accounts/list/chart-of-accounts-list-column-model'
import { BookingService } from '../../../modules/banking/services/index'

// actions
const ACTION_PREFIX = '/chartOfAccounts'
const FINSIHED_FETCHING_LIST_SETTING = `${ACTION_PREFIX}/finishedFetchingListSetting`
const ERROR_FETCHING_LIST_SETTING = `${ACTION_PREFIX}/errorFetchingListSetting`
const SHOW_LOADER = `${ACTION_PREFIX}/showLoader`
const HIDE_LOADER = `${ACTION_PREFIX}/hideLoader`
const SET_COLUMNS = `${ACTION_PREFIX}/setColumns`
const SET_PAGINATION = `${ACTION_PREFIX}/setPagination`
const SET_SEARCH_TERM = `${ACTION_PREFIX}/setSearchTerm`
const REFRESH = `${ACTION_PREFIX}/refresh`
const STOP_REFRESHING = `${ACTION_PREFIX}/stopRefresh`
const FINISHED_FETCHING_REVENUE_ACCOUNTS = `${ACTION_PREFIX}/finishedFetchingRevenueAccounts`
const FINISHED_FETCHING_TAX_PHRASES = `${ACTION_PREFIX}/finishedFetchingTaxPhrases`

// reducer
const initialState = {
  isLoading: true,
  error: null,
  items: [],
  setting: {
    columns: [],
  },
  searchTerm: '',
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered chartOfAccounts
    totalCount: 0, // count of all chartOfAccounts
    limit: 20, // max chartOfAccounts on page
  },
  shouldRefresh: false,
  revenueAccounts: [],
  phrases: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINSIHED_FETCHING_LIST_SETTING:
      const { setting } = action
      return Object.assign({}, state, {
        error: null,
        setting,
      })

    case FINISHED_FETCHING_REVENUE_ACCOUNTS:
      const { accounts: revenueAccounts } = action
      return { ...state, revenueAccounts }

    case FINISHED_FETCHING_TAX_PHRASES:
      const { phrases } = action
      return { ...state, phrases }

    case SHOW_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_COLUMNS:
      const { columns } = action
      return { ...state, setting: { ...setting, columns } }

    case SET_PAGINATION:
      const { pagination } = action
      return { ...state, pagination: { ...state.pagination, ...pagination } }

    case SET_SEARCH_TERM:
      const { searchTerm } = action
      return Object.assign({}, state, {
        searchTerm,
      })

    case REFRESH:
      return Object.assign({}, state, {
        shouldRefresh: true,
      })

    case STOP_REFRESHING:
      return Object.assign({}, state, {
        shouldRefresh: false,
      })

    case ERROR_FETCHING_LIST_SETTING:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    default:
      return state
  }
};

// action creators
export const showLoader = () => {
  return {
    type: SHOW_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_LOADER,
  }
}

export const refreshList = () => {
  return {
    type: REFRESH,
  }
}

export const stopRefreshing = () => {
  return {
    type: STOP_REFRESHING,
  }
}

export const setColumns = (columns) => {
  return { type: SET_COLUMNS, columns }
}

export const setPagination = (pagination) => {
  return {
    type: SET_PAGINATION,
    pagination,
  }
}

export const setSearchTerm = (searchTerm) => {
  return {
    type: SET_SEARCH_TERM,
    searchTerm,
  }
}

const finishedFetchingChartOfAccountsListSetting = (setting) => {
  return {
    type: FINSIHED_FETCHING_LIST_SETTING,
    setting,
  }
}

const errorFetchingChartOfAccountsListSetting = (error) => {
  return {
    type: ERROR_FETCHING_LIST_SETTING,
    error,
  }
}

const finishedFetchingRevenueAccounts = (accounts) => {
  return {
    type: FINISHED_FETCHING_REVENUE_ACCOUNTS,
    accounts,
  }
}

const finishedFetchingTaxPhrases = (phrases) => {
  return {
    type: FINISHED_FETCHING_TAX_PHRASES,
    phrases,
  }
}

export const fetchChartOfAccountsListSetting = () => {
  return (dispatch) => {
    BookingService.chartOfAccounts.getListSetting()
      .then((body) => {
        const {
          data: { columns },
          meta: {
            defaultSort,
            sortBy,
          },
        } = body

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const chartOfAccountsColumns = sanitizedColumns.map((column) => {
          return new ChartOfAccountsListColumnModel(column)
        })

        dispatch(finishedFetchingChartOfAccountsListSetting({ columns: chartOfAccountsColumns }))
      })
      .catch((error) => {
        dispatch(errorFetchingChartOfAccountsListSetting(error))
      })
  }
}

export const fetchRevenueAccounts = () => {
  return (dispatch) => {
    BookingService.chartOfAccounts.getRevenueAccounts()
      .then(({ data: { vatGroups } }) => {
        const flattenedVatGroups = vatGroups.reduce((acc, currentGroup) => {
          (currentGroup?.accounts || []).forEach((item) => acc.push({
            ...item,
            groupKey: currentGroup.key,
            defaultInVatGroup: currentGroup.default === item.accountNo,
          }))
          return acc
        }, [])
        dispatch(finishedFetchingRevenueAccounts(flattenedVatGroups))
      })
  }
}

export const fetchTaxPhrases = () => {
  return (dispatch) => {
    BookingService.taxPhrases.getTaxPhrases()
      .then(({ data: { phrases } }) => {
        dispatch(finishedFetchingTaxPhrases(phrases))
      })
  }
}
